import React from 'react';
import { Container } from '../../common/organisms';

export const FormEntryModal = () => (
  <Container>
    <div id="form-entry" />
  </Container>
);
